export const MAX_PER_PAGE = 100;

const FIRST_PAGE = 1;
const MAX_PAGES = 50;

type PaginatedPayload<TItem> = {
  total_pages: number;
  data: TItem[];
};

export async function fetchAllPages<TItem>(
  fetchPage: (page: number) => Promise<PaginatedPayload<TItem>>,
): Promise<TItem[]> {
  const firstPage = await fetchPage(FIRST_PAGE);
  const lastPage = Math.min(firstPage.total_pages, MAX_PAGES);

  if (lastPage <= FIRST_PAGE) return firstPage.data;

  const remainingPages = Array.from(
    { length: lastPage - FIRST_PAGE },
    (_, index) => index + FIRST_PAGE + 1,
  );

  const pages = await Promise.all(remainingPages.map((page) => fetchPage(page)));

  return pages.reduce<TItem[]>((items, page) => [...items, ...page.data], firstPage.data);
}
